import React, { useState, useCallback, useEffect, useContext} from 'react'
import styled, { ThemeContext } from 'styled-components'
// import { BigNumber } from 'bignumber.js'
import DPlayer from 'dplayer'

// components
import Modal, { ModalProps } from '../../components/bakery/Modal'
import Row from '../../components/Row'
// import { ButtonConfirmed } from '../../components/Button'
// import Loader from '../../components/Loader'
// import VoteModal from '../../pages/BakeryArtworks/components/VoteModal'
// import ArtworkBtn from './button/ArtworkBtn'

// utils
// import { BIGNUMBER_FMT } from '../../constants/bakery'
import { ArtworksProps } from '../../constants/artwork'
// import { artInfoUrl } from '../../constants/artwork'
// import { MARKETTYPE } from '../../constants/bakery/nft'

// hooks
// import { useActiveWeb3React } from '../../hooks'
// import useModal from '../../hooks/bakery/useModal'

// import useUserBids from '../../hooks/nft/useUserBids'
// import useUserAsks from '../../hooks/nft/useUserAsks'
// import useVoting from '../../hooks/nft/useVoting'
// import useApproveVote from '../../hooks/nft/useApproveVote'
// import useAllowanceVote from '../../hooks/nft/useAllowanceVote'
// import useInterval from '../../hooks/useInterval'

// import { stopPropagation } from '../../utils/func'
// import { useMarketLevel } from '../../state/market/hooks'
// import { getArtworks, getArtworksV2, getArtworksV3 } from '../../service/nft'

const VedioModal = styled(Row)`
  position: fixed;
  padding: 50px 0;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    justify-content: center;
    width: 290px;
  `}
`

const VedioCard = styled(Row)`
  flex-direction: column;
  padding: 24px 20px;
  font-family: Baloo Da;
  position: relative;
  height: auto;
  .dplayer-controller {
    height: 0px!important;
    overflow: hidden!important;
  }
  .video .dplayer-controller {
    height: 41px!important;
    overflow: visible!important;
  }
  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding: 18px 13px 20px;
  `}
`

const VedioPlay = styled.div`
  width: 438px;
  height: 584px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 258px;
    height: 344px;
  `}
`

// const PlayFoot = styled.div`
//   padding: 0 5px;
//   width: 100%;
//   display: flex;
//   flex-direction: column;
//   align-items: flex-end;
//   overflow: hidden;
// `

// const Title = styled.div`
//   margin: 25px 0 15px 0;
//   width: 100%;
//   font-size: 22px;
//   line-height: 25px;
//   max-height: 50px;
//   font-family: Yuanti SC;
//   font-weight: bold;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   display: -webkit-box;
//   -webkit-line-clamp: 2;
//   -webkit-box-orient: vertical;
//   word-wrap: break-word;
//   color: ${({ theme }) => theme.bsText4};
//   ${({ theme }) => theme.mediaWidth.upToMedium`
//     margin: 18px 0 10px 0;
//     font-size: 16px;
//     overflow: hidden;
//   `}
// `

// const PlayLevel = styled.div`
//   margin: 0 0 25px 0;
//   font-size: 16px;
//   line-height: 17px;
//   font-family: Yuanti SC;
//   font-weight: 700;
//   color: ${({ theme }) => theme.bsText4};
//   img {
//     width: 20px;
//     height: 20px;
//     vertical-align: middle;
//   }
//   ${({ theme }) => theme.mediaWidth.upToMedium`
//     margin: 0 0 15px 0;
//     font-size: 16px;
//   `}
// `
// const Button = styled(ButtonConfirmed)`
//   border: none;
//   font-size: 14px;
//   width: 244px;
//   height: 40px;
//   border-radius: 10px;
//   padding: 0;
//   ${({ theme }) => theme.mediaWidth.upToMedium`
//     width: 219px;
//   `}
// `
const Disappear = styled.img`
  position: absolute;
  top: 0px;
  right: -30px;
  cursor: pointer;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    top: -25px;
    right: 10px;
  `}
`
// const VoteFlag = styled(Button)`
//   position: absolute;
//   z-index: 10;
//   top: 40px;
//   right: 30px;
//   width: auto;
//   height: 28px;
//   border-radius: 6px;
//   font-family: Baloo Da;
//   text-align: center;
//   padding: 0 17px;
//   white-space: nowrap;
//   color: ${({ theme }) => theme.bsText7};
//   background: ${({ theme }) => theme.bsText9};
//   &:hover{
//     background: ${({ theme }) => theme.bsText9};
//   }
//   ${({ theme }) => theme.mediaWidth.upToMedium`
//     top: 35px;
//     width: auto;
//   `}
// `
// const VoteAutoRow = styled.div`
//   flex-wrap: nowrap;
//   justify-content: center;
//   display:flex;
//   align-items:center;
// `
// const GoInfo = styled.div`
//   cursor: pointer;
//   color: ${({ theme }) => theme.bsText7};
// `

interface PlayModalProps extends ModalProps {
  history: any
  video: ArtworksProps
  isMyArtwork: any
  status: number
  canReview: boolean
  type: string
  tokenName?: string
}

const PlayModal: React.FC<PlayModalProps> = ({
  onDismiss,
  history = '',
  video = {
    tokenId: '',
    name: '',
    description: '',
    imageUrl: '',
    fileUrl: '',
    price: '',
    attributes: {
      artist: '',
      edition: '',
      image_min: '',
      public_profile_link: ''
    },
    nftType: 0,
    auctionPrice: '',
    maxBidPrice: ''
  },
  isMyArtwork = false,
  status = 1,
  canReview = false,
  type = '',
  tokenName = ''
}) => {
  const theme = useContext(ThemeContext)
  // const { account, chainId } = useActiveWeb3React()
  // const symbol = tokenName || 'BAKE'
  const p: any = null
  const [player, setPlayer] = useState(p)
  const [videoplay, setVideoplay] = useState<HTMLDivElement | null>(null)
 
  useEffect(() => {
    if (videoplay) {
      const dp = new DPlayer({
        container: videoplay,
        autoplay: true,
        mutex: true,
        video: {
          url: video.fileUrl
        }
      })
      setPlayer(dp)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoplay])

  useEffect(() => {
    if (player) {
      player.on('canplaythrough', () => {
        let p = videoplay
        if (p) {
          p.className = `${p.className + ' video'}`
        }
      })
    }
  }, [player, videoplay])

  // const level = useMarketLevel()

  // const [artworks, setArtworks] = useState({...deepCopy(video)})
  // const getArtworkInfo = useCallback(async() => {
  //   let params = {
  //     nftType: video.nftType,
  //     ids: video.nftType + '-' + video.tokenId
  //   }
  //   let getData
  //   if (video.level === 'v1') {
  //     getData = getArtworks
  //   } else if (video.level === 'v2') {
  //     getData = getArtworksV2
  //   } else {
  //     getData = getArtworksV3
  //   }
  //   getData(chainId as number, params, (err: any, data: any) => {
  //     if (err) return
  //     if (data.code !== 0) return
  //     const dataAry = data.data.list || []
  //     const artworks = dataAry.map((d: any) => {
  //       return {
  //         ...d,
  //         level: video.level,
  //         tokenId: d.nftId,
  //         maxBidPrice: (d.maxBidPrice && !Number(d.maxBidPrice)) && (d.auctionPrice && Number(d.auctionPrice)) ? d.auctionPrice.toString() : d.maxBidPrice,
  //         ...((d.price && Number(d.price)) ? {price: d.price.toString()} : {price: ''}),
  //         ...((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake) ? {auctionPrice: d.auctionPrice.toString()} : {auctionPrice: ''})
  //       }
  //     })
  //     setArtworks(artworks.length > 0 ? artworks[0] : {...deepCopy(video)})
  //   })
  // }, [video, chainId])

  // useInterval(() => {
  //   getArtworkInfo()
  // }, account ? 10000 : null)

  const dismiss = useCallback(async () => {
    if (player) {
      player.destroy()
    }
    if (onDismiss) {
      onDismiss()
    }
  }, [onDismiss, player])

  //授权投票
  // const allowanceVote = useAllowanceVote()

  // // 获取我的竞价
  // const getBids = useUserBids(type)
  // const emptyBids: any[] = []
  // const [ids, setIds] = useState(emptyBids)
  // const getIds = useCallback(async() => {
  //   const bids = await getBids()
  //   if (bids.length) {
  //     const bidsId = bids.map((d: any) => {
  //       return d[0]
  //     })
  //     setIds(bidsId)
  //   }
  // }, [getBids])

  // 获取我的挂单
  // const getAsks = useUserAsks(type)
  // const emptyAsks: any[] = []
  // const [aksIds, setAskIds] = useState(emptyAsks)
  // const getAskIds = useCallback(async() => {
  //   const asks = await getAsks()
  //   if (asks.length) {
  //     const asksId = asks.map((d: any) => {
  //       return d[0]
  //     })
  //     setAskIds(asksId)
  //   }
  // }, [getAsks])


  // useEffect(() => {
  //   if (account) {
  //     getAskIds()
  //     getIds()
  //   }
  // }, [getBids, getIds, getAskIds, getAsks, account, video])

  //授权投票
  // const [requestedApprovalVote, setRequestedApprovalVote] = useState(false)
  // const onApproveVote = useApproveVote()
  // const handleApproveVote = useCallback(async (event) => {
  //   stopPropagation(event)
  //   try {
  //     setRequestedApprovalVote(true)
  //     const txHash = await onApproveVote()
  //     if (!txHash) {
  //       setRequestedApprovalVote(false)
  //     }
  //   } catch (e) {
  //     console.log(e)
  //   }
  // }, [onApproveVote, setRequestedApprovalVote])

  // 投票
  // const {onVote} = useVoting(video.tokenId, type, video.owner) 
  // const handleVote = useCallback(async (amount: string) => {
  //   try {
  //     const txHash = await onVote(amount)
  //     console.log('handleVote', txHash)
  //   } catch (e) {
  //     console.log(e)
  //   }
  // }, [onVote])

  // const handVote = ((event: any) => {
  //   stopPropagation(event)
  //   onVoting()
  // })
  // const nextInfo = async () => {
  //   if (onDismiss) {
  //     onDismiss()
  //   }
  //   let url = '/artworkInfo/'
  //   // history.push(artInfoUrl[type] + video.tokenId + '/' + (isMyArtwork ? 1 : 0) + '/' + status)
  //   history.push(`${url}${video.nftId}/${isMyArtwork ? '1' : '0'}/${video.status}?type=${video.nftType}&level=${video.nftLevel}`)
  // }
  // const [onVoting] = useModal(
  //   <VoteModal
  //     onConfirm={handleVote}
  //     tokenId={video.tokenId}
  //     name={video.name}
  //     nftType={video.nftType}
  //     nftId={video.nftId}
  //     type={type}
  //   />
  // )

  return (
    <VedioModal onClick={dismiss}>
      <Modal maxWidth={478} padding="0px" backgroundColor={theme.bsBg36}>
        <Disappear onClick={dismiss} src="images/artworks/disappear.svg" alt=""></Disappear>
        <VedioCard onClick={event => {event.stopPropagation()}}>
          {/* {
            [
              MARKETTYPE.BAKERYBSCARTWORK,
              MARKETTYPE.BAKERYARTWORK,
              MARKETTYPE.MEME, 
              MARKETTYPE.MUSKDOGE, 
              MARKETTYPE.ONEINCH,
              MARKETTYPE.SFPARTWORK,
              MARKETTYPE.LOVE,
              MARKETTYPE.RACANFT
            ].includes(type) ?
              allowanceVote?.toNumber() 
              ? 
              <VoteFlag onClick={handVote}>Vote</VoteFlag>
              : 
              <VoteFlag
                onClick={handleApproveVote}
                disabled={requestedApprovalVote}
                altDisabledStyle={requestedApprovalVote}
              >
                {
                  requestedApprovalVote ? (
                    <VoteAutoRow>
                      Approving <Loader stroke="white" />
                    </VoteAutoRow>
                  ) : 'Approve Vote'
                }
              </VoteFlag>
            : null
          } */}
          <VedioPlay ref={setVideoplay as any}></VedioPlay>
          {/* <PlayFoot>
            <Title>
              {video.name + '—' + (video.author || (' #' + video.tokenId))}
            </Title>
            <RowBetween style={{alignItems: 'center'}}>
              <PlayLevel style={{fontFamily: 'Baloo Da', fontSize: '24px', fontWeight: 'normal'}}>
                <img style={{marginRight: '6px'}} src={'/images/bakery/icon_' + (tokenName || 'BAKE').toLocaleLowerCase() + '.svg'} alt=""/>
                {video.price ? (new BigNumber(!video.auctionPrice ? video.price : video.maxBidPrice).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT)) : '-'}
              </PlayLevel>
              {
                [
                  MARKETTYPE.BAKERYARTWORK,
                  MARKETTYPE.MEME, 
                  MARKETTYPE.MUSKDOGE, 
                  MARKETTYPE.ONEINCH,
                  MARKETTYPE.SFPARTWORK,
                  MARKETTYPE.LOVE,
                  MARKETTYPE.RACANFT
                ].includes(type) ? (
                  <PlayLevel>
                    <img src="/images/bakery/icon_favierate_red.svg" alt=""/>
                    {video.votes ? video.votes : '-'}
                  </PlayLevel>
                ) : null
              }
              <PlayLevel>
                <GoInfo onClick={nextInfo}>{'More >>'}</GoInfo>
              </PlayLevel>
            </RowBetween>
            <ArtworkBtn
              artwork={artworks}
              status={status}
              isMyArtwork={isMyArtwork || (artworks.owner === account && !artworks.price)}
              ids={ids}
              myAksIds={aksIds}
              marketType={type}
              symbol={symbol}
            />
          </PlayFoot> */}
        </VedioCard>
      </Modal>
    </VedioModal>
  )
}
export default PlayModal
